export const CLIENT_SET = "CLIENT_SET";
export const CLIENT_UNSET = "CLIENT_UNSET";
export const SET_ACTIVE_MODEL = "SET_ACTIVE_MODEL";
export const REGISTER_REQUESTING = "REGISTER_REQUESTING";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const REGISTER_ERROR_ADMIN = "REGISTER_ERROR_ADMIN";
export const SET_THEME = "SET_THEME";

export const LOGIN_REQUESTING = "LOGIN_REQUESTING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_NOT_EXIST = "LOGIN_NOT_EXIST";
export const LOGIN_EXISTING = "LOGIN_EXISTING";
export const LOGOUT = "LOGOUT";
export const EMAIL_VERIFY = "E_VERIFY";
export const EMAIL_VERIFY_ERROR = "E_VERIFY_ERROR";
export const EMAIL_VERIFY_SUCCESS = "E_VERIFY_SUCCESS";
export const URL_VERIFY_ERROR = "U_VERIFY_ERROR";
export const URL_VERIFY_SUCCESS = "U_VERIFY_SUCCESS";
export const EMAIL_ALREADY_EXIST = "E_ALREADY_EXIST";

//Message constant

export const NOT_REGISTER_MSG =
  "Email does not exist! Please try again our contact support.";
export const INCORRECT_E_P = "Incorrect email or password!";
export const EMAIL_VERIFY_MSG = "Please verify your email";
export const EMAIL_VERIFY_ERROR_MSG = "Your email is invaild";
export const EMAIL_VERIFY_SUCCESS_MSG = "Your email is verified";
export const URL_VERIFY_ERROR_MSG = "Your URL is invaild";
export const URL_VERIFY_SUCCESS_MSG = "Your URL is verified";
export const EMAIL_EXIST_MSG = "This email is already exist!";
export const UNKNOWN_MSG = "Unkown error!";

//title
export const AGENT_TITLE = "IYKYK Agent";
